import React from 'react';
import { EmailConfirmationModal } from './EmailConfirmationModal';
import { initializeRootAndReturnRender, unmountReactNode } from '@common/utils/react';

export const initEmailConfirmation = function () {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const { root, render } = initializeRootAndReturnRender(container);
  const close = () => {
    unmountReactNode(root);
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
  };

  render(<EmailConfirmationModal close={close} />);
};
